import { Controller } from '@hotwired/stimulus';

// Turbo does not re-fetch a <turbo-frame> restored from the snapshot cache: it
// replays the frozen HTML, whose listeners are dead (interactive elements become
// inert after a back/forward navigation). The [complete] attribute encodes the
// "already loaded" state INTO the snapshot; removing it right before caching marks
// the frame as not loaded, so it re-fetches its [src] on restoration.
// Source: https://github.com/hotwired/turbo/pull/487
export default class extends Controller {
  reset() {
    this.element.removeAttribute('complete');
  }
}
